import * as Scrivito from "scrivito";
import FirstLevel from "./FirstLevel";
import SecondLevel from "./SecondLevel";
import ThirdLevel from "./ThirdLevel";

function NavigationList(props) {
  const { navigationLevel, ...otherProps } = props;
  switch (navigationLevel) {
    case 1:
      return <FirstLevel {...otherProps} />;
    case 2:
      return <SecondLevel {...otherProps} />;
    case 3:
      return <ThirdLevel {...otherProps} />;
    default:
      return null;
  }
}

export default Scrivito.connect(NavigationList);
